export default "__VITE_ASSET___O3rY8V2__"